var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 479,
    height: 368,
    viewBox: "0 0 479 368",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_240_7022)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_240_7022)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.789 260H105.142C83.1554 259.985 62.0276 252.429 46.1817 238.915C30.3357 225.4 21.0002 206.975 20.1294 187.495C19.2586 168.016 26.92 148.993 41.5098 134.409C56.0996 119.825 76.4866 110.81 98.4029 109.252C101.528 89.6845 111.494 71.4779 126.898 57.194C142.302 42.91 162.369 33.2676 184.276 29.6232C206.183 25.9788 228.827 28.5158 249.023 36.8775C269.219 45.2391 285.95 59.0044 296.862 76.2369C316.877 70.0938 338.502 69.3759 358.978 74.1748C379.455 78.9737 397.855 89.0719 411.832 103.181C425.809 117.291 434.73 134.772 437.456 153.395C440.182 172.018 436.59 190.94 427.138 207.745C421.591 222.93 410.762 236.166 396.203 245.554C381.645 254.942 364.107 259.999 346.105 260H331.789Z",
    fill: "url(#paint0_linear_240_7022)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.105 258.95C355.246 258.95 364.232 257.656 372.816 255.104C381.117 252.636 388.909 249.034 395.978 244.399C402.964 239.818 409.089 234.33 414.181 228.087C419.337 221.767 423.317 214.814 426.011 207.422L426.039 207.346L426.079 207.275C429.662 200.927 432.421 194.211 434.279 187.314C436.192 180.217 437.161 172.885 437.161 165.52C437.161 159.18 436.441 152.845 435.021 146.689C433.636 140.691 431.571 134.791 428.881 129.153C426.241 123.617 422.972 118.278 419.166 113.283C415.397 108.336 411.067 103.683 406.299 99.4551C401.53 95.2269 396.283 91.3883 390.703 88.0458C385.07 84.6715 379.048 81.7733 372.805 79.4318C366.446 77.0471 359.792 75.2156 353.027 73.9882C346.085 72.7286 338.94 72.09 331.789 72.09C319.95 72.09 308.33 73.8176 297.25 77.2247L296.315 77.5122L295.83 76.7475C286.813 62.5316 273.697 50.5929 257.901 42.2222C249.912 37.9889 241.329 34.7175 232.391 32.499C223.169 30.2103 213.591 29.0498 203.922 29.0498C190.917 29.0498 178.221 31.1252 166.189 35.2183C154.565 39.1724 143.901 44.8843 134.495 52.1952C125.142 59.4641 117.381 68.0407 111.427 77.6866C105.326 87.5695 101.338 98.2375 99.5752 109.394L99.4432 110.229L98.4951 110.295C87.889 111.031 77.6846 113.507 68.1654 117.654C58.9159 121.684 50.6564 127.134 43.6164 133.853C29.1506 147.66 21.184 165.65 21.184 184.507C21.184 194.557 23.4036 204.306 27.7813 213.483C29.8854 217.894 32.4897 222.148 35.5219 226.128C38.5256 230.07 41.9751 233.777 45.7746 237.146C49.5741 240.515 53.755 243.574 58.2009 246.237C62.6893 248.925 67.4873 251.234 72.4618 253.1C82.8118 256.982 93.8068 258.95 105.141 258.95H331.789H346.105ZM346.105 260H331.789H105.141C58.1194 260 20 226.2 20 184.507C20 144.825 54.5296 112.293 98.4027 109.248C105.66 63.3326 150.137 28 203.922 28C243.824 28 278.603 47.4452 296.862 76.2329C307.804 72.868 319.556 71.0402 331.789 71.0402C390.639 71.0402 438.345 113.341 438.345 165.52C438.345 180.696 434.309 195.038 427.138 207.745C416.085 238.068 383.984 260 346.105 260Z",
    fill: "white",
    fillOpacity: 0.5
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_240_7022)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_240_7022)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.818 283C123.418 283.018 139.636 308.341 139.636 318.182C139.636 322.908 137.759 327.44 134.417 330.781C131.076 334.123 126.544 336 121.818 336C117.092 336 112.56 334.123 109.219 330.781C105.877 327.44 104 322.908 104 318.182C104 308.342 120.219 282.982 121.818 283Z",
    fill: "#42A0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.233 324.841C110.014 325.386 112.276 323.147 113.287 319.84C114.298 316.534 113.674 313.413 111.894 312.868C110.113 312.324 107.85 314.563 106.84 317.869C105.829 321.176 106.453 324.297 108.233 324.841Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.818 283C216.418 283.018 232.636 308.341 232.636 318.182C232.636 322.908 230.759 327.44 227.417 330.781C224.076 334.123 219.544 336 214.818 336C210.092 336 205.56 334.123 202.219 330.781C198.877 327.44 197 322.908 197 318.182C197 308.342 213.219 282.982 214.818 283Z",
    fill: "#42A0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.233 324.841C203.014 325.386 205.276 323.147 206.287 319.84C207.298 316.534 206.674 313.413 204.894 312.868C203.113 312.324 200.85 314.563 199.84 317.869C198.829 321.176 199.453 324.297 201.233 324.841Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.818 283C309.418 283.018 325.636 308.341 325.636 318.182C325.636 322.908 323.759 327.44 320.417 330.781C317.076 334.123 312.544 336 307.818 336C303.092 336 298.56 334.123 295.219 330.781C291.877 327.44 290 322.908 290 318.182C290 308.342 306.219 282.982 307.818 283Z",
    fill: "#42A0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.233 324.841C296.014 325.386 298.276 323.147 299.287 319.84C300.298 316.534 299.674 313.413 297.894 312.868C296.113 312.324 293.85 314.563 292.84 317.869C291.829 321.176 292.453 324.297 294.233 324.841Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.818 205C170.418 205.018 186.636 230.341 186.636 240.182C186.636 244.908 184.759 249.44 181.417 252.781C178.076 256.123 173.544 258 168.818 258C164.092 258 159.56 256.123 156.219 252.781C152.877 249.44 151 244.908 151 240.182C151 230.342 167.219 204.982 168.818 205Z",
    fill: "#42A0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.233 246.841C157.014 247.386 159.276 245.147 160.287 241.84C161.298 238.534 160.674 235.413 158.894 234.868C157.113 234.324 154.85 236.563 153.84 239.869C152.829 243.176 153.453 246.297 155.233 246.841Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.818 205C268.418 205.018 284.636 230.341 284.636 240.182C284.636 244.908 282.759 249.44 279.417 252.781C276.076 256.123 271.544 258 266.818 258C262.092 258 257.56 256.123 254.219 252.781C250.877 249.44 249 244.908 249 240.182C249 230.342 265.219 204.982 266.818 205Z",
    fill: "#42A0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.233 246.841C255.014 247.386 257.276 245.147 258.287 241.84C259.298 238.534 258.674 235.413 256.894 234.868C255.113 234.324 252.85 236.563 251.84 239.869C250.829 243.176 251.453 246.297 253.233 246.841Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.345 260H91.913C73.3426 259.986 55.4976 252.789 42.1137 239.915C28.7298 227.041 20.8447 209.489 20.1092 190.933C19.3737 172.377 25.8448 154.256 38.1677 140.364C50.4906 126.471 67.71 117.884 86.221 116.4C88.8608 97.7599 97.2781 80.4166 110.289 66.8099C123.299 53.2032 140.248 44.0179 158.752 40.5463C177.255 37.0747 196.381 39.4915 213.439 47.4567C230.497 55.4218 244.628 68.5345 253.845 84.9499C270.75 79.0981 289.015 78.4142 306.31 82.9856C323.605 87.557 339.146 97.1764 350.952 110.617C362.757 124.057 370.292 140.71 372.594 158.45C374.896 176.19 371.862 194.214 363.879 210.223C359.194 224.688 350.047 237.296 337.751 246.239C325.455 255.182 310.641 260 295.437 260H283.345Z",
    fill: "url(#paint1_linear_240_7022)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.437 259C303.157 259 310.748 257.767 317.998 255.336C325.009 252.985 331.59 249.554 337.56 245.139C343.462 240.775 348.635 235.547 352.936 229.6C357.29 223.58 360.652 216.957 362.928 209.915L362.951 209.843L362.985 209.775C366.011 203.728 368.341 197.33 369.911 190.761C371.526 184 372.345 177.015 372.345 169.999C372.345 163.96 371.737 157.925 370.537 152.062C369.368 146.348 367.623 140.728 365.352 135.357C363.121 130.084 360.361 124.997 357.146 120.24C353.962 115.527 350.306 111.095 346.278 107.067C342.25 103.039 337.819 99.3828 333.106 96.1988C328.348 92.9845 323.261 90.2237 317.988 87.9932C312.617 85.7216 306.997 83.9769 301.283 82.8077C295.42 81.6079 289.385 80.9995 283.345 80.9995C273.346 80.9995 263.531 82.6452 254.172 85.8908L253.383 86.1646L252.973 85.4362C245.357 71.8943 234.279 60.5217 220.937 52.5479C214.189 48.5153 206.94 45.399 199.391 43.2857C191.602 41.1055 183.512 40 175.345 40C164.361 40 153.638 41.977 143.475 45.876C133.657 49.6427 124.65 55.0837 116.705 62.048C108.806 68.9722 102.251 77.1422 97.2213 86.3308C92.0685 95.7451 88.7006 105.907 87.2113 116.535L87.0998 117.33L86.299 117.393C77.3408 118.094 68.7219 120.453 60.6818 124.403C52.8694 128.242 45.8932 133.434 39.947 139.834C27.7289 152.987 21 170.123 21 188.087C21 197.66 22.8748 206.947 26.5723 215.689C28.3495 219.891 30.5491 223.943 33.1102 227.734C35.6472 231.489 38.5607 235.02 41.7699 238.23C44.9791 241.439 48.5104 244.352 52.2655 246.889C56.0565 249.45 60.109 251.65 64.3106 253.427C73.0525 257.125 82.3391 259 91.9127 259H283.345H295.437ZM295.437 260H283.345H91.9127C52.1966 260 20 227.803 20 188.087C20 150.286 49.1646 119.297 86.221 116.396C92.3504 72.6574 129.917 39 175.345 39C209.048 39 238.422 57.5232 253.845 84.946C263.087 81.7407 273.012 79.9995 283.345 79.9995C333.051 79.9995 373.345 120.294 373.345 169.999C373.345 184.456 369.936 198.118 363.879 210.223C354.544 239.108 327.431 260 295.437 260Z",
    fill: "white",
    fillOpacity: 0.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_240_7022",
    x: 16,
    y: 24,
    width: 426.345,
    height: 240,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_240_7022"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_240_7022",
    x: 0,
    y: 0,
    width: 478.345,
    height: 292,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.44901 0 0 0 0 0.730915 0 0 0 0 0.970833 0 0 0 0.596 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_240_7022"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_240_7022",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_240_7022",
    x: 16,
    y: 35,
    width: 361.345,
    height: 305,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_240_7022"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_240_7022",
    x: 0,
    y: 11,
    width: 413.345,
    height: 357,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.501961 0 0 0 0 0.501961 0 0 0 0 0.501961 0 0 0 0.302 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_240_7022"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_240_7022",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_240_7022",
    x1: 229.203,
    y1: 28.0024,
    x2: 327.823,
    y2: 296.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.604
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_240_7022",
    x1: 196.698,
    y1: 39.0024,
    x2: 299.341,
    y2: 287.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.604
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRain);
export default __webpack_public_path__ + "static/media/rain.42ebfe75be44d2868e14094310403fb5.svg";
export { ForwardRef as ReactComponent };